if (!customElements.get("professionals-carousel")) {
  class ProfessionalsCarousel extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const swiperEl = this.querySelector(".swiper");
      if (!swiperEl) return;

      const options = {
        slidesPerView: 1,
        spaceBetween: 5,
        pagination: {
          el: this.querySelector(".swiper-pagination"),
          clickable: true,
        },
        navigation: {
          nextEl: this.querySelector(".swiper-button-next"),
          prevEl: this.querySelector(".swiper-button-prev"),
        },
        autoplay: {
          delay: 10000,
          disableOnInteraction: false,
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
        },
      };

      this.swiper = new Swiper(swiperEl, options);
      swiperEl.classList.add("is-initialized");
    }
  }

  customElements.define("professionals-carousel", ProfessionalsCarousel);
}
